import {
  SET_CURRENT_STORE
} from '../../../actions/actionTypes';
import { forcePlaExitIfOutOfRegion } from '../../../utils/plaConfigurationUtils';
import {
  Utils,
  QUERY_PARAM_CONFIGURATION_ID_FOR_SELECTIONS,
  QUERY_PARAM_REGION_ID,
  QUERY_PARAM_PLA_CONFIGURATION_GUID
} from '../../../utils/urlUtils';

export const localStoreChangeMiddleware = ({ dispatch, getState }) => (next) => (action) => {
  if (!action) return;
  next(action);
  if (action && action.type === SET_CURRENT_STORE) {
    const { storeId, zipcode } = action?.payload;
    const { plaConfiguration, store: { previousStoreNumber } } = getState();
    const configurationIdForSelections = Utils.getParameterByName(QUERY_PARAM_CONFIGURATION_ID_FOR_SELECTIONS);
    const regionId = Utils.getParameterByName(QUERY_PARAM_REGION_ID);
    const plaId = Utils.getParameterByName(QUERY_PARAM_PLA_CONFIGURATION_GUID);
    forcePlaExitIfOutOfRegion(
      regionId,
      storeId,
      previousStoreNumber,
      plaId,
      configurationIdForSelections,
      plaConfiguration?.plaConfigurationDetails?.storeNumbers,
      dispatch,
      zipcode,
      true,
    );
  }
};